<!-- 分页器 -->
<template>
  <div class="pager">
    <!--<div class="countNumber">共{{countNumber}}条数据</div>-->
    <div class="pagesizeList" v-show="showPagesize">
      <select v-model="pagesize_">
        <option disabled value>请选择</option>
        <option v-for="item in pagesizeList" :key="item">{{item}}</option>
      </select>
    </div>
    <div class="pageList">
      <div
        :class="currentPage === 1?'btn leftBtn':'leftBtn btn'"
        @click.stop="currentPage === 1?'':changeCurrentPage(false)"
      ></div>
      <div
        v-for="num in pageNumsArr_"
        :key="num"
        :class="num === currentPage ? 'btn pageNum no_select':'btn pageNum'"
        @click.stop="num === currentPage ? '':selectCurrentPage(num)"
      >{{num}}</div>
      <div
        :class="currentPage === pageNums ? 'rightBtn btn':'rightBtn btn'"
        @click.stop="currentPage === pageNums?'':changeCurrentPage(true)"
      ></div>
    </div>
    <!--<div class="inputCurrentNum">
			<div class="text">前往</div>
			<input class="inputBox" type="number" v-model="inputCurrentNum" @blur="changeCurrentPageByInput">
			<div class="text">页</div>
    </div>-->
  </div>
</template>
<script>
export default {
  name: "pager",
  props: {
    countNumber: {
      type: Number,
      default: 15
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pagesizeList: {
      type: Array,
      default: [5, 10, 20, 50, 100]
    },
    pagesize: {
      type: Number,
      default: 5
    },
    showPagesize: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      pageNums: 0, // 总页数
      pageNumsArr: [1, 2, 3],
      pageNumsArr_: [1, 2, 3],
      pagesize_: 5,
      inputCurrentNum: ""
    };
  },
  methods: {
    selectCurrentPage(num) {
      if (typeof num === "number") {
        this.$emit("update:currentPage", num);
      }
    },
    createNumArr(nums) {
      let arr = [];
      const maxNum = 20;
      for (let i = 1; i < nums + 1; i++) {
        arr.push(i);
      }
      if (this.pageNumsArr.length <= this.currentPage) {
        this.$emit("update:currentPage", 1);
      }
      this.pageNumsArr = arr;
      if (arr.length > this.pagesize_) {
        this.pageNumsArr_ = arr.slice(0, this.pagesize_);
      }
    },
    changeCurrentPage(bool) {
      let currentPage = this.currentPage * 1;
      if (bool) {
        currentPage++;
      } else {
        currentPage--;
      }
      this.$emit("update:currentPage", currentPage);
    },
    changeCurrentPageByInput() {
      const inputCurrentNum = this.inputCurrentNum * 1;
      const length = this.inputCurrentNum.length;
      const isNumber = typeof inputCurrentNum === "number" ? true : false;
      if (isNumber && length <= 4) {
        if (inputCurrentNum <= this.pageNums && inputCurrentNum !== 0) {
          this.$emit("update:currentPage", inputCurrentNum);
        }
        this.inputCurrentNum = "";
      } else {
        return;
      }
    },
    cutPageNumsArr() {
      let newArr = [];
      const pageNumsArr = this.cloneArray(this.pageNumsArr);
      const maxNum = 5;
      const len = this.pageNums;
      if (len > 5) {
        if (this.currentPage > len - 5) {
          newArr = pageNumsArr.splice(len - 5, 5);
        } else if (this.currentPage < 5) {
          newArr = pageNumsArr.splice(0, 5);
        } else {
          newArr = pageNumsArr.splice(this.currentPage - 3, 5);
        }
      } else {
        newArr = pageNumsArr;
      }
      this.pageNumsArr_ = newArr;
    },
    // 复制一个数组对象
    cloneArray(oldarr) {
      let newarr = new Array();
      for (let [key, value] of oldarr.entries()) {
        newarr.push(value);
      }
      return newarr;
    }
  },
  watch: {
    countNumber() {
      const pageNums = Math.ceil(this.countNumber / this.pagesize_);
      this.pageNums = pageNums;
    },
    pageNums() {
      this.createNumArr(this.pageNums);
    },
    pagesize() {
      // console.log(123);
      this.pagesize_ = this.pagesize;
    },
    pagesize_() {
      const pageNums = Math.ceil(this.countNumber / this.pagesize_);
      this.pageNums = pageNums;
      this.$emit("update:pagesize", this.pagesize_ * 1);
    },
    currentPage() {
      this.cutPageNumsArr();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./Pager.scss";
</style>
